import styled from 'styled-components';

export const GoogleIcon = styled.svg`
  width: 20px;
  height: 20px;
`;
